(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ss-home-carousel"] && !Shopify.designMode) return;
  try {
    (function(){
  function init(root){
    if(root.dataset.carouselReady)return;
    var track=root.querySelector('[data-ss-home-track]');
    var buttons=root.querySelectorAll('[data-ss-home-scroll]');
    if(!track)return;
    root.dataset.carouselReady='true';
    function update(){
      var max=Math.max(0,track.scrollWidth-track.clientWidth);
      buttons.forEach(function(button){button.disabled=button.dataset.ssHomeScroll==='-1'?track.scrollLeft<2:track.scrollLeft>=max-2});
    }
    buttons.forEach(function(button){
      button.addEventListener('click',function(){
        var card=track.querySelector('.ss-home-carousel__card');
        if(!card)return;
        var gap=parseFloat(getComputedStyle(track).columnGap)||0;
        track.scrollBy({left:Number(button.dataset.ssHomeScroll)*(card.getBoundingClientRect().width+gap),behavior:'smooth'});
      });
    });
    var down=false,moved=false,startX=0,startLeft=0;
    track.addEventListener('pointerdown',function(event){
      if(event.pointerType!=='mouse'||event.button!==0)return;
      down=true;moved=false;startX=event.clientX;startLeft=track.scrollLeft;
    });
    track.addEventListener('pointermove',function(event){
      if(!down)return;
      var distance=event.clientX-startX;
      if(Math.abs(distance)>5){moved=true;track.classList.add('is-dragging');event.preventDefault();track.scrollLeft=startLeft-distance}
    });
    window.addEventListener('pointerup',function(){
      if(!down)return;
      down=false;track.classList.remove('is-dragging');
      setTimeout(function(){moved=false},0);
    });
    track.addEventListener('click',function(event){
      if(moved){event.preventDefault();event.stopPropagation();moved=false}
    },true);
    track.addEventListener('dragstart',function(event){event.preventDefault()});
    track.addEventListener('scroll',update,{passive:true});
    window.addEventListener('resize',update);
    update();
  }
  function initAll(scope){scope.querySelectorAll('.ss-home-carousel').forEach(init)}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',function(){initAll(document)});
  else initAll(document);
  document.addEventListener('shopify:section:load',function(event){initAll(event.target)});
})();
  } catch(e) { console.error(e); }
})();

})();
